<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 运营</el-breadcrumb-item>
                <el-breadcrumb-item> 项目日志管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item style='margin-bottom: 0'>
                                <el-select filterable clearable size='mini' v-model='queryParams.projectName'
                                           placeholder='项目名'>
                                    <el-option
                                        v-for='item in projectInfoList'
                                        :key='item.id'
                                        :label='item.cnName'
                                        :value='item.name'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='fileInfoList'
                      @selection-change='handleSelectionChange'>
                <!--<el-table-column align='center' type='selection' width='55' />-->
                <el-table-column align='center' label='文件名' prop='fileName' />
                <el-table-column align='center' label='项目' prop='projectName' />
                <el-table-column align='center' label='存档大小'>
                    <template slot-scope='scope'>
                        <span>{{ computeFileSize(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip='true' align='center' label='文件URL'>
                    <template slot-scope='scope'>
                        <el-button type='text' size='mini' @click='handleCopyUrl(scope.row.url)'>复制</el-button>
                    </template>
                </el-table-column>
                
                <el-table-column :show-overflow-tooltip='true' align='center' label='提交时间' prop='createTime' />
                <el-table-column fixed='right' align='center' width='200' class-name='small-padding fixed-width'
                                 label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='handleAdd(scope.row)'
                        >覆盖
                        </el-button>
                        <el-button
                            icon='el-icon-download'
                            size='mini'
                            type='text'
                            @click='handleDownloadFile(scope.row)'
                        >下载
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='prev, pager, next'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :before-close='cancel' :visible.sync='open' append-to-body width='40%'>
                <el-form label-position='right' ref='form' label-width='100px'>
                    <el-form-item v-if='updateStatus' label='URL' prop='url'>
                        <el-input disabled size='mini' v-model='currentFileInfo.url' />
                    </el-form-item>
                    <el-form-item v-if='updateStatus' label='存储路径' prop='url'>
                        <el-input disabled size='mini' v-model='currentFileInfo.objectKey' />
                    </el-form-item>
                    
                    <cotton-file-upload ref='file' :custom-upload-operation-status='true'
                                        :custom-upload-function='overwriteArchive' :data='currentFileInfo'
                                        v-if='!updateStatus' trigger-type='drag'
                                        accept='*' />
                </el-form>
                <div v-if='updateStatus' slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { deleteWhiteUrl } from '@/components/api/white';
import { deepCopy } from '@/utils/object';
import { copyContent } from '@/utils/string/cottonPlugin';
import { fileAdminApi } from '@/components/api/File/fileInfoAdmin';
import { FileUtils } from '@/utils/file';
import { fileWebApi } from '@/components/api/File/fileWeb';
import CottonFileUpload from '@/components/component/CottonFileUpload.vue';
import { queryProjectInfoList } from '@api/ProjectInfo';
import { archiveApi } from '@api/operation/archive/ArchiveApi';

export default {
    name: 'ArchiveManage',
    components: { CottonFileUpload },
    data() {
        return {
            uploadData: {
                saveFolder: '/vue/kaudhf',
                accessType: 'PUBLIC'
                
            },
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            uploadOpen: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                type: 'archive',
                projectName: undefined,
                
                sortSqlList: [
                    'createTime desc'
                ]
            },
            updateStatus: false,
            
            fileOwnerTypeList: [
                {
                    label: '玩家',
                    value: 'PLAYER'
                },
                {
                    label: '项目',
                    value: 'GAME_PROJECT'
                },
                {
                    label: '内部文件',
                    value: 'INTERNAL'
                }
            ],
            fileAccessTypeList: [
                {
                    label: '玩家',
                    value: 'PLAYER'
                },
                {
                    label: '公共',
                    value: 'PUBLIC'
                },
                {
                    label: '内部文件',
                    value: 'INTERNAL'
                }
            ],
            storageModeTypeList: [
                {
                    label: '本地',
                    value: 0
                }
            ],
            
            fileInfoList: [],
            currentFileInfo: {
                ownerType: 'INTERNAL',
                accessType: 'INTERNAL'
            },
            projectInfoList: []
        };
    },
    computed: {
        computeFileSize() {
            return (fileInfo) => {
                return FileUtils.computeFileSize(fileInfo.size);
            };
        },
        computeFileAccessType() {
            return (fileInfo) => {
                switch (fileInfo.accessType) {
                    case 'PUBLIC':
                        return '所有人';
                    case 'PLAYER':
                        return '玩家';
                    case 'INTERNAL':
                        return '内部员工';
                    default:
                        return '未知';
                }
            };
        },
        computeFileType() {
            return (fileInfo) => {
                let fileName = fileInfo.fileName;
                let splitArr = fileName.split('.');
                if (splitArr.length >= 2) {
                    return splitArr[splitArr.length - 1];
                } else {
                    return '未知';
                }
            };
        },
        computeImgSrc() {
            return (file) => {
                if (file.url) {
                    return file.url + '?time=' + file.id;
                }
                return file.url;
            };
        },
        computeFileOwner() {
            return (fileInfo) => {
                switch (fileInfo.ownerType) {
                    case 'PLAYER':
                    case 'GAME_PROJECT':
                    case 'INTERNAL':
                }
            };
        },
        computeStorageMode() {
            return (storageMode) => {
                switch (storageMode) {
                    case 0:
                        return '本地存储';
                    default:
                        return '未知';
                }
            };
        }
    },
    created() {
        // 查询项目信息
        queryProjectInfoList({ pageSize: 100000 }).then(result => {
            if (result.code === 200) {
                if (result.data && result.data.result) {
                    result.data.result.forEach(v => {
                        this.projectInfoList.push(v);
                    });
                }
            }
        });
        this.getList();
    },
    methods: {
        handleCopyUrl(url) {
            copyContent(url);
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        /** 查询字典类型列表 */
        getList() {
            this.loading = true;
            fileAdminApi.queryList(this.queryParams).then(response => {
                    if (response.code === 200) {
                        this.fileInfoList = response.data.result;
                        this.queryParams.total = response.data.total;
                        this.loading = false;
                        this.queryParams.pageNum = response.data.pageNum;
                    } else {
                        this.loading = false;
                    }
                }
            );
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
            this.$refs.file.initFileList();
            this.getList();
            this.currentFileInfo = {
                ownerType: 'INTERNAL',
                accessType: 'INTERNAL'
            };
        },
        // 表单重置
        reset() {
        
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                type: 'archive',
                projectName: undefined,
                
                sortSqlList: [
                    'createTime desc'
                ]
            };
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd(row) {
            this.reset();
            this.open = true;
            this.title = '文件上传';
            this.updateStatus = false;
            this.currentApiInfo = {};
            this.uploadOpen = true;
            this.currentFileInfo = deepCopy(row);
        },
        handleBatchDelete() {
            let idList = this.ids;
            const obj = this;
            this.$modal.confirm(`是否删除 ${idList.length} 条数据?`).then(function() {
                return deleteWhiteUrl(idList);
            }).then(result => {
                if (result.code === 200) {
                    message.success('删除成功');
                    obj.getList();
                    return;
                }
            });
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            this.open = true;
            this.title = '修改文件信息';
            this.updateStatus = true;
            this.currentFileInfo = deepCopy(row);
        },
        handleDownloadFile(row) {
            fileWebApi.download(row.id).then(result => {
                if (result.code && result.code !== 200) {
                
                } else {
                    let url = window.URL.createObjectURL(new Blob([result]));
                    let link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = url;
                    link.setAttribute('download', row.fileName);
                    document.body.appendChild(link);
                    link.click();
                }
            });
        },
        /** 提交按钮 */
        submitForm: function() {
            if (this.updateStatus) {
                fileWebApi.update(this.currentFileInfo).then(result => {
                    if (result.code === 200) {
                        message.success('修改成功');
                        this.getList();
                        this.open = false;
                    }
                });
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否删除"' + row.fileName + '"文件？').then(function() {
                return fileWebApi.deleteFile({ id: row.id });
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        overwriteArchive(fileInfo) {
            archiveApi.overwrite({ fileId: this.currentFileInfo.id, uploadFile: fileInfo.uploadFile }).then(result => {
                if (result.code === 200) {
                    message.success('覆盖成功');
                    this.open = false;
                    this.getList();
                }
            });
        }
    }
};
</script>
<style>
.el-tree {
    min-width: 100%;
    display: inline-block;
}

.tree {
    overflow: auto;
    max-height: 60vh;
}
</style>
